import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import DynamicCard from '../../../../../CustomComponents/DynamicHomeCard';
import { width } from "../../../../../CustomComponents/DynamicHomeCard/DynamicHomeCardStyles";

import CustomDropdown from '../../../../../CustomComponents/CustomDropDown';
import CustomTextInput from '../../../../../CustomComponents/CustomtextInput';
import CustomRadioButtonGroup from '../../../../../CustomComponents/CustomRadioButton';
// import RightArrow from '../../../../../../assets/images/RightArrow@2x.png'
import CustomDateInput from '../../../../../CustomComponents/CustomDateInput';
import { dateComparison, displayErrorMessage, displayKudzuplusErrorMessage, handleAmountInputLimitTo2decimal, retrieveData, storeData } from '../../../../../../utils';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../../../network/NetworkUtils';
import { GET_ACCOUNTS_FOR_TRANSFER, GET_FREQUENCIES, GET_HOLIDAYS, SAVING_CARD_CODE, STATUS_SUCCESS_CODE, TINK_LINK_ENABLED_CHECK } from '../../../../../../network/URLConstants';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../../../CustomComponents/Loader';
import CustomDatePicker from '../../../../../CustomComponents/CustomDateInput';
import moment from 'moment';
import { ACH, appTheme,HOLIDAYS_STORAGE_KEY } from '../../../../../../helpers/utils/Utils.js';
import { ONE_TIME_FREQUENCY_TYPE, RECURRING_FREQUENCY_TYPE, FREQUENCY_DISPLAY_ORDER, buildTransferFrequencyOptions, getFrequencyLabel as getFrequencyLabelUtil, isRecurringEndDateMissing, resolveTransferAccountOptions } from '../../../../../../helpers/utils/TransferMoneyUtils.js';
import { useLocation } from 'react-router-dom';
import logFirebaseEvents from '../../../../../LogFirebaseEvents/index.js';
import CardHeading from '../../../../../CustomComponents/CardHeading/index.js';
import { GET_NEW_TRANSFER_ACCOUNTS } from '../../../../../../network/URLConstants';
import { selectIsTransferMoneyFeatureEnabled } from '../../../../../../Redux/selectors';

const getTodayAsDate = () => new Date(new Date().toUTCString().substr(0, 25));
const isWeekendDate = (date) => {
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
};
const isHolidayDate = (date, holidays = []) => {
    const formatted = moment(date).format('YYYY-MM-DD');
    return holidays.some((holiday) => moment(holiday).format('YYYY-MM-DD') === formatted);
};

const TransferMoneyForm = (props) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
    const appThemeData = appTheme(kudzuPlusTrue)
    const { onNextSelect, onConfirmDisplayData, onTransferFundPayload, isExternalAccountAddedSuccessfully, onSetIsExternalAccountAddedSuccessfully, openHeadsUpModal } = props
    const { t } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const currentPath = window.location.pathname;
    const location = useLocation();


    const transferMoneyPayloadObj = useSelector(state => state.transferMoneyPayload);
    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const twoFactAuthenticationDone = useSelector(state => state.twoFactAuthenticationDone);
    const selectedItem = cards?.[0]
    const SavingsAccount = cards?.find(({ AccountTypeBit63 }) => AccountTypeBit63 === SAVING_CARD_CODE);

    const [isLoading, setIsLoading] = useState(false);
    const [recurringFrequencyArray, setRecurringFrequencyArray] = useState([])
    const [accounts, setAccounts] = useState([]);
    const [transferFromAccountOptions, setTransferFromAccountOptions] = useState([]);
    const [transferToAccountOptions, setTransferToAccountOptions] = useState([]);
    const [isShowContent, setIsShowContent] = useState(false);
    const [isReset, setIsReset] = useState(false);

    const [transferFromError, setTransferFromError] = useState(null);
    const [transferToError, setTransferToError] = useState(null);
    const [amountError, setAmountError] = useState('');
    const [freqTypeError, setFreqTypeError] = useState(null);
    const [recurringFreqTypeError, setRecurringFreqTypeError] = useState(null)
    const [transferDateError, setTransferDateError] = useState(null);
    const [endDateError, setEndDateError] = useState(null);
    const [CalendarMinDate, setCalendarMinDate] = useState('');
    const [CalendarMaxDate, setCalendarMaxDate] = useState('');
    const [oneTimeSelectedDate, setOneTimeSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [bankHolidayDates, setBankHolidayDates] = useState([]);
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const frequencyArray = [{ displayText: "Recurring", type: RECURRING_FREQUENCY_TYPE, label: t("recurring") }, { displayText: "One Time", type: ONE_TIME_FREQUENCY_TYPE, label: t("one_time") }]
    const frequencyDisplayOrder = FREQUENCY_DISPLAY_ORDER
    const getFrequencyLabel = (displayText) => getFrequencyLabelUtil(displayText, t);

    const selectedTransferFromAccount = transferMoneyPayloadObj?.FromAccount;
    const selectedTransferToAccount = transferMoneyPayloadObj?.ToAccount
    const enteredAmount = transferMoneyPayloadObj?.Amount;
    const frequency = transferMoneyPayloadObj?.Frequency?.displayText
    const frequencyType = transferMoneyPayloadObj?.Frequency?.type
    const isOneTimeFrequency = frequencyType === ONE_TIME_FREQUENCY_TYPE
    const isRecurringFrequency = frequencyType === RECURRING_FREQUENCY_TYPE
    const recurringFrequencyName = transferMoneyPayloadObj?.FrequencyType?.displayText;
    const recurringFrequency = transferMoneyPayloadObj?.FrequencyType?.type;
    const selectedTransferDate = transferMoneyPayloadObj?.TransferDate
    const selectedStartDate = transferMoneyPayloadObj?.startDate
    const selectedEndDate = transferMoneyPayloadObj?.EndDate;
    const memo = transferMoneyPayloadObj?.Memo;

    const isAchTransfer = selectedTransferFromAccount?.AccountType === ACH || selectedTransferToAccount?.AccountType === ACH;
    const activeTransferDate = isOneTimeFrequency ? selectedTransferDate : selectedStartDate;
    const shouldShowAchDateDisclaimer = useMemo(() => {
        if (!isAchTransfer || !activeTransferDate) return false;
        return isWeekendDate(activeTransferDate) || isHolidayDate(activeTransferDate, bankHolidayDates);
    }, [isAchTransfer, activeTransferDate, bankHolidayDates]);


    const transferFrequencyOptions = useMemo(
        () => buildTransferFrequencyOptions(recurringFrequencyArray, t),
        [recurringFrequencyArray, t]
    );

    //const setFrequencyFun = (value) => {
    //    dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "Frequency", 'value': value } })
    //    setFreqTypeError("")
    //    setRecurringFreqTypeError("");
    //}
    const setFrequencyFun = (value) => {
        const isOneTime = (value?.type || value?.Type) === ONE_TIME_FREQUENCY_TYPE;

        dispatch({
            type: 'TRANSFER_MONEY_PAYLOAD',
            payload: {
                'values': {
                    Frequency: frequencyArray.find((option) => option.type === (isOneTime ? ONE_TIME_FREQUENCY_TYPE : RECURRING_FREQUENCY_TYPE)),
                    FrequencyType: isOneTime ? "" : value,
                    EndDate: null
                }
            }
        })
        setEndDate(null)

        setFreqTypeError("")
        setRecurringFreqTypeError("");
    }
    const setRecurringFrequencyFun = (value) => {
        setFreqTypeError("")
        setRecurringFreqTypeError("");
        dispatch({
            type: 'TRANSFER_MONEY_PAYLOAD',
            payload: {
                'values': {
                    FrequencyType: value,
                    EndDate: null
                }
            }
        });
        setEndDate(null)
    }

    useEffect(() => {
        getHolidays();
    }, [])

    useEffect(() => {
        if (isOneTimeFrequency) {
            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "FrequencyType", 'value': "" } })
            setFreqTypeError("")
            setRecurringFreqTypeError("");
            setEndDateError("");
        }
        if (isRecurringFrequency && recurringFrequency) {
            setRecurringFreqTypeError("");
            setFreqTypeError("")
            setRecurringFreqTypeError("");
        }

    }, [frequency, recurringFrequency])

    useEffect(() => {
        if (selectedStartDate) setTransferDateError("");
        if (selectedEndDate) setEndDateError("");
    }, [selectedStartDate, selectedEndDate])

    ////API CALLS-----------------------------------------

     const getNewTransferAccount = async (accountId, field) => {
         if (cards == undefined || cards == null) {
            return
        }
        try {
            setIsLoading(true);
            const deviceId = await retrieveData('updatedDeviceId')
            const url = GET_NEW_TRANSFER_ACCOUNTS(global.selectedAccountServiceCardKey, accountId, field)
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
           
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                const counterAccounts = responseJson.Response.Accounts || [];
                // Keep every available account selectable in the field the user just used
                const nextOptions = resolveTransferAccountOptions(field, counterAccounts, accounts, {
                    from: transferFromAccountOptions,
                    to: transferToAccountOptions
                });
                setTransferFromAccountOptions(nextOptions.from);
                setTransferToAccountOptions(nextOptions.to);
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching new transfer accounts:', error);
            setIsLoading(false);
        }
    }


    const fetchAccounts = async () => {
        if (cards == undefined || cards == null) {
            return
        }
        var cardKey = cards !== null ? cards[0].CardKey : 0
        var isSavingsCard = false
        for (var i = 0; i < cards.length; i++) {
            if (global.selectedAccountServiceCardKey == cards[i].CardKey) {
                cardKey = cards[i].CardKey
                if (cards[i].AccountTypeBit63 == SAVING_CARD_CODE) {
                    isSavingsCard = true
                }
            }
        }
        try {
            setIsLoading(true);

            const deviceId = await retrieveData('updatedDeviceId')
            // const cardKey = cards !== null ?  cards[0].CardKey : 0;  //checking cardkey
            //get verified user account
            const url = GET_ACCOUNTS_FOR_TRANSFER.replace('{CARD_KEY}', cardKey) + '?statusCode=ACT&ach=false'

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            setIsShowContent(true);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                dispatch({ type: 'TRANSFER_ACCOUNTS', payload: { transferAccounts: responseJson.Response.Accounts } });
                setIsLoading(false);
               
                // Check if current path is /AccountServices/smiONECard/TransferMoney
                const isSmiOneCardTransferMoney = currentPath.toLowerCase() === '/accountservices/smionecard/transfermoney';
               
                if (isSmiOneCardTransferMoney) {
                    // For smiONECard TransferMoney, filter accounts based on AccountType
                    const primaryAccounts = responseJson.Response.Accounts.filter(account => account.AccountType === "Primary");
                    const spendingAccounts = responseJson.Response.Accounts.filter(account => account.AccountType === "Spending");
                   
                    setAccounts(responseJson.Response.Accounts);
                    setTransferFromAccountOptions(responseJson.Response.Accounts); // From dropdown shows only Primary accounts
                    setTransferToAccountOptions(responseJson.Response.Accounts); // To dropdown shows only Spending accounts
                } else if (!isSavingsCard) {
                    setAccounts(responseJson.Response.Accounts)
                    setTransferFromAccountOptions(responseJson.Response.Accounts)
                    setTransferToAccountOptions(responseJson.Response.Accounts)
                } else {
                    var accounts = []
                    for (var jIndex = 0; jIndex < responseJson.Response.Accounts.length; jIndex++) {
                        const account = responseJson.Response.Accounts[jIndex]
                        if (account.AccountType != ACH) {
                            accounts.push(account)
                        }
                    }
                    setAccounts(accounts)
                    setTransferFromAccountOptions(accounts)
                    setTransferToAccountOptions(accounts)

                }
                setIsShowContent(true);
            }

        } catch (error) {
            dispatch({ type: 'TRANSFER_ACCOUNTS', payload: { transferAccounts: null } });
        }
    }

    const fetchFrequency = async () => {
        if (cards == undefined || cards == null) {
            return
        }
        try {
            const url = GET_FREQUENCIES.replace("{CARD_KEY}", cards[0].CardKey) + '?featureType=TransferFund'
            const deviceId = await retrieveData('updatedDeviceId');
            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            setIsLoading(true)
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                setRecurringFrequencyArray(responseJson.Response)

            }

        } catch (error) {
        }

    }

    useEffect(() => {
        fetchAccounts();
        fetchFrequency();
    }, [])
    useEffect(() => {
        if (isExternalAccountAddedSuccessfully) fetchAccounts();
    }, [isExternalAccountAddedSuccessfully])



    // DropDown Logic -------
    const setTransferDropDownLogic = () => {
        // Check if current path is /AccountServices/smiONECard/TransferMoney
        const isSmiOneCardTransferMoney = currentPath.toLowerCase() === '/accountservices/smionecard/transfermoney';

        // Skip the dropdown logic for smiONECard TransferMoney as we handle filtering in fetchAccounts
        if (isSmiOneCardTransferMoney) {
            return;
        }

        // The new transfer money flow resolves the eligible counter accounts from the API
        // (getNewTransferAccount), which also allows Spending to Spending transfers.
        if (isTransferMoneyFeatureEnabled) {
            return;
        }


        //Transfer From logic
        const checkingCardKey = cards !== null ? cards[0].CardKey : 0;
        const savingCardKey = cards?.[1]?.CardKey || ''
        if (selectedTransferFromAccount && !selectedTransferToAccount) {
            //External account ---> checking
            if (selectedTransferFromAccount.ACHAccountInternalId !== 0) {
                const checkingAccount = accounts.filter((acc) => acc.ACHAccountInternalId === 0 && acc.AccountId === checkingCardKey)
                setTransferToAccountOptions([...checkingAccount])
            }
            // Internal Account
            else {
                //Checking ---> External+saving
                if (selectedTransferFromAccount.AccountId === checkingCardKey) {
                    const saving_externalAccount = accounts.filter((acc) => acc.AccountId !== checkingCardKey)
                    setTransferToAccountOptions([...saving_externalAccount])

                }
                //Saving ---> cheking
                else {
                    const checkingAccount = accounts.filter((acc) => acc.AccountId === checkingCardKey)
                    setTransferToAccountOptions([...checkingAccount])

                }

            }

        }
        //Transfer To logic
        if (selectedTransferToAccount && !selectedTransferFromAccount) {
            //External account ---> checking
            if (selectedTransferToAccount.ACHAccountInternalId !== 0) {
                const checkingAccount = accounts.filter((acc) => acc.ACHAccountInternalId === 0 && acc.AccountId === checkingCardKey)
                setTransferFromAccountOptions([...checkingAccount])
            }
            // Internal Account
            else {
                //Checking ---> External+saving
                if (selectedTransferToAccount.AccountId === checkingCardKey) {
                    const saving_externalAccount = accounts.filter((acc) => acc.AccountId !== checkingCardKey)
                    setTransferFromAccountOptions([...saving_externalAccount])

                }
                //Saving ---> cheking
                else {
                    const checkingAccount = accounts.filter((acc) => acc.AccountId === checkingCardKey)
                    setTransferFromAccountOptions([...checkingAccount])

                }

            }

        }
    }

    useEffect(() => {

        if (isShowContent) setTransferDropDownLogic();
        if (selectedTransferFromAccount) setTransferFromError("")
        if (selectedTransferToAccount) setTransferToError("")

    }, [selectedTransferFromAccount, selectedTransferToAccount, isShowContent])




    // Amount Validation Logic--------
    const amountValidation = () => {
        let checkingBalance = 0
        let checkingCardKey = 0
        let savingBalance = 0
        let savingCardKey = 0
        let primaryCardkey = 0
        let primaryCardBalance = 0

        if (parseFloat(enteredAmount) === 0) {
            setAmountError(t("amount_validation"));
            return;
        }else{
            setAmountError('');
        }

        if (cards !== null) {
            if (SavingsAccount) {
                savingBalance = SavingsAccount.Balance
                savingCardKey = SavingsAccount.CardKey
            }
            checkingBalance = cards[0].Balance
            checkingCardKey = cards[0].CardKey
            const primaryKey = cards.find(card => card?.AccountTypeBit63 === 1);
            primaryCardkey =  primaryKey?.CardKey;
            primaryCardBalance = primaryKey?.Balance

        }
        //if internal account
        if (selectedTransferFromAccount && selectedTransferFromAccount.ACHAccountInternalId === 0) {
            //if checking card and amount is more than balance
            if (selectedTransferFromAccount.AccountId === checkingCardKey && enteredAmount > checkingBalance && enteredAmount !== 0) {
                setAmountError(`${t("amount_error_msg")}`)
            } else if (selectedTransferFromAccount.AccountId === checkingCardKey && enteredAmount <= checkingBalance && enteredAmount !== 0) {
                setAmountError('');
            }
            if (SavingsAccount) {

                if (selectedTransferFromAccount.AccountId === savingCardKey && enteredAmount > savingBalance && enteredAmount !== 0) {
                    setAmountError(`${t("amount_error_msg")}`)
                }
                else if (selectedTransferFromAccount.AccountId === savingCardKey && enteredAmount <= savingBalance && enteredAmount !== 0) {
                    setAmountError('')
                }
            }

            if (selectedTransferFromAccount.AccountId === primaryCardkey && enteredAmount > primaryCardBalance && enteredAmount !== 0) {
                setAmountError(`${t("amount_error_msg")}`)
            } else if (selectedTransferFromAccount.AccountId === primaryCardkey && enteredAmount <= primaryCardBalance && enteredAmount !== 0) {
                setAmountError('')
            }
        }
    }

    useEffect(() => {
        if (enteredAmount) amountValidation();
    }, [enteredAmount, selectedTransferFromAccount])

    const handleOnBlurAmountField = (e) => {

        if (enteredAmount) amountValidation();
        else setAmountError("Please enter amount")

    }


    //onSubmit Validation-----------
    const handleValidation = () => {
        let isProceed = true;
        const reqError = "Required"
        if (!selectedTransferFromAccount) {
            setTransferFromError('Please select Account.')
            isProceed = false
        }
        if (!selectedTransferToAccount) {
            setTransferToError('Please select Account.')
            isProceed = false
        }
        if (!enteredAmount) {
            setAmountError('Please enter amount.')
            isProceed = false
        } else if (parseFloat(enteredAmount) === 0) {
            setAmountError(t('amount_validation'))
            isProceed = false
        }else{
            setAmountError('');
        }
        if (amountError == t('amount_error_msg')) {
            setAmountError(t('amount_error_msg'))
            isProceed = false
        }
         if (frequency == "" && !recurringFrequency) {
            setFreqTypeError('Please select frequency.')
            isProceed = false
        }
        if (isRecurringFrequency && !recurringFrequency) {
            setRecurringFreqTypeError('Please select frequency.')
            isProceed = false
        }
        if (!isOneTimeFrequency && !selectedStartDate) {
            setTransferDateError('Please select date.')
            isProceed = false
        }
        if (isOneTimeFrequency && !selectedTransferDate) {
            setTransferDateError('Please select date.')
            isProceed = false
        }
        if (isRecurringEndDateMissing(frequencyType, selectedEndDate)) {
            setEndDateError('Please select date.')
            isProceed = false
        }

        return isProceed;
    }

    //on successful process setData
    const setDataOnSubmit = () => {
        let formattedEndDate = ''
        let formattedTransferDate = ''
        if (!isOneTimeFrequency) {
            formattedTransferDate = moment(selectedStartDate).format('YYYY-MM-DD')
            formattedEndDate = moment(selectedEndDate).format('YYYY-MM-DD')
        } else {
            formattedTransferDate = moment(selectedTransferDate).format('YYYY-MM-DD')
            formattedEndDate = moment(selectedEndDate).format('YYYY-MM-DD')
        }


        let transferFundPayloadObj = {
            "FromAccount": selectedTransferFromAccount?.AccountId.toString(),
            "ToAccount": selectedTransferToAccount?.AccountId.toString(),
            "FromAccountType": selectedTransferFromAccount?.AccountType,
            "ToAccountType": selectedTransferToAccount?.AccountType,
            "Amount": enteredAmount,
            "Frequency": transferMoneyPayloadObj?.Frequency?.type,
            "TransferDate": formattedTransferDate,
            "Memo": memo
        }

        // var transferDateStatus = dateComparison(formattedTransferDate)
        var transferDateStatus = dateComparison(moment(formattedTransferDate).format('MMMM DD, YYYY'))
        console.log("transferDateStatus---", transferDateStatus)
        if (transferDateStatus === "Future") transferFundPayloadObj.IsScheduledTransfer = true
        else transferFundPayloadObj.IsScheduledTransfer = false
        if (!isOneTimeFrequency) {

            transferFundPayloadObj.FrequencyType = recurringFrequency;
            transferFundPayloadObj.EndDate = formattedEndDate;
        }

        console.log("transferFundPayloadObj---", transferFundPayloadObj)

        const confirmDisplayData = [
            {
                'title': t("transfer_money_from"),
                'value': selectedTransferFromAccount?.AccountName
            },
            {
                'title': t("transfer_money_to"),
                'value': selectedTransferToAccount?.AccountName
            },
            {
                'title': t("amount"),
                'value': enteredAmount
            },
            {
                'title': t("frequency"),
                'value': isRecurringFrequency && recurringFrequencyName ? `${getFrequencyLabel(frequency)} , ${getFrequencyLabel(recurringFrequencyName)}` : getFrequencyLabel(frequency)
            },
            {
                'title': !isOneTimeFrequency ? t("start_date") : t("transfer_date"),
                'value': moment(!isOneTimeFrequency ? selectedStartDate : selectedTransferDate).format('MMMM DD, YYYY')
            },
            {
                'title': t("memo_optional"),
                'value': memo
            },
            {
                'title': 'Tranfer date object',
                'value': moment(!isOneTimeFrequency ? selectedStartDate : selectedTransferDate).format('MMMM DD, YYYY')
            },
            {
                'title': t("end_date"),
                'value': selectedEndDate ? moment(selectedEndDate).format('MMMM DD, YYYY') : ''
            },
            {
                'title': t("from_account"),
                'value': selectedTransferFromAccount
            },
            {
                'title': t("to_account"),
                'value': selectedTransferToAccount
            },

        ]

        onTransferFundPayload(transferFundPayloadObj)
        onConfirmDisplayData(confirmDisplayData)
        onNextSelect(true);
    }

    const handleNextClick = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Next_Clicked", "Next_Clicked", "", "");
        const isProceed = handleValidation();

        if (isProceed) {
            setDataOnSubmit();
        }


    }

    const resetEachFieldValue = () => {
        setTransferFromAccountOptions(accounts)
        setTransferToAccountOptions(accounts)
        setTransferFromError(null)
        setTransferToError(null)
        setAmountError('')
        setFreqTypeError(null)
        setRecurringFreqTypeError(null)
        setTransferDateError(null)
        setEndDateError(null)

        const transferMoneyPayload = {
            "FromAccount": null,
            "ToAccount": null,
            "Amount": null,
            "Frequency": 'One Time',
            "FrequencyType": null,
            "TransferDate": new Date(new Date().toUTCString().substr(0, 25)),
            "EndDate": null,
            "Memo": null
        }

        dispatch({ type: "TRANSFER_MONEY_PAYLOAD", payload: { transferMoneyPayload } })
    }

    const handleReset = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Reset_Account_Clicked", "Reset_Account_Clicked", "", "");
        resetEachFieldValue();
        setIsReset(prev => !prev);
        dispatch({ type: "RESET_TRANSFER_PAYLOAD" })
    }


    const getHolidays = async () => {
        if (cards == undefined || cards == null) {
            return
        }
        const storedHolidays = await retrieveData(HOLIDAYS_STORAGE_KEY);
        const isStoredHolidaysValid = storedHolidays && Array.isArray(storedHolidays.Holidays) && storedHolidays.Holidays.length > 0
            && new Date(storedHolidays.EndDate) >= getTodayAsDate();
        if (isStoredHolidaysValid) {
            processHolidaysData(storedHolidays);
            return;
        }

        var url = GET_HOLIDAYS + "?cardKey=" + cards[0].CardKey;

        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        setIsLoading(true)
        const response = await GetRequest(url, headers);
        setTimeout(() => {
            setIsLoading(false)
        }, 500);
        // const response = { "Response": { "StartDate": "2023-08-17T00:00:00Z", "EndDate": "2024-02-18T00:00:00Z", "Holidays": ["2023-09-04T00:00:00", "2023-10-09T00:00:00", "2023-11-10T00:00:00", "2023-11-23T00:00:00", "2023-12-25T00:00:00", "2024-01-01T00:00:00", "2024-01-15T00:00:00", "2023-08-19T00:00:00Z", "2023-08-20T00:00:00Z", "2023-08-26T00:00:00Z", "2023-08-27T00:00:00Z", "2023-09-02T00:00:00Z", "2023-09-03T00:00:00Z", "2023-09-09T00:00:00Z", "2023-09-10T00:00:00Z", "2023-09-16T00:00:00Z", "2023-09-17T00:00:00Z", "2023-09-23T00:00:00Z", "2023-09-24T00:00:00Z", "2023-09-30T00:00:00Z", "2023-10-01T00:00:00Z", "2023-10-07T00:00:00Z", "2023-10-08T00:00:00Z", "2023-10-14T00:00:00Z", "2023-10-15T00:00:00Z", "2023-10-21T00:00:00Z", "2023-10-22T00:00:00Z", "2023-10-28T00:00:00Z", "2023-10-29T00:00:00Z", "2023-11-04T00:00:00Z", "2023-11-05T00:00:00Z", "2023-11-11T00:00:00Z", "2023-11-12T00:00:00Z", "2023-11-18T00:00:00Z", "2023-11-19T00:00:00Z", "2023-11-25T00:00:00Z", "2023-11-26T00:00:00Z", "2023-12-02T00:00:00Z", "2023-12-03T00:00:00Z", "2023-12-09T00:00:00Z", "2023-12-10T00:00:00Z", "2023-12-16T00:00:00Z", "2023-12-17T00:00:00Z", "2023-12-23T00:00:00Z", "2023-12-24T00:00:00Z", "2023-12-30T00:00:00Z", "2023-12-31T00:00:00Z", "2024-01-06T00:00:00Z", "2024-01-07T00:00:00Z", "2024-01-13T00:00:00Z", "2024-01-14T00:00:00Z", "2024-01-20T00:00:00Z", "2024-01-21T00:00:00Z", "2024-01-27T00:00:00Z", "2024-01-28T00:00:00Z", "2024-02-03T00:00:00Z", "2024-02-04T00:00:00Z", "2024-02-10T00:00:00Z", "2024-02-11T00:00:00Z", "2024-02-17T00:00:00Z", "2024-02-18T00:00:00Z"] }, "ResponseCode": 2000, "Messages": [], "Echo": { "RequestTime": "2023-08-18T11:28:02.1985931Z", "ResponseTime": "2023-08-18T11:28:02.2454931Z", "ITransactionID": "8317b946-2f52-45c3-a83e-426d0060e97c" } }
        // const responseObj = { "Response": { "StartDate": "2023-08-20T00:00:00Z", "EndDate": "2024-02-19T00:00:00Z", "Holidays": ["2023-09-04T00:00:00", "2023-10-09T00:00:00", "2023-11-10T00:00:00", "2023-11-23T00:00:00", "2023-12-25T00:00:00", "2024-01-01T00:00:00", "2024-01-15T00:00:00", "2023-08-19T00:00:00Z", "2023-08-20T00:00:00Z", "2023-08-26T00:00:00Z", "2023-08-27T00:00:00Z", "2023-09-02T00:00:00Z", "2023-09-03T00:00:00Z", "2023-09-09T00:00:00Z", "2023-09-10T00:00:00Z", "2023-09-16T00:00:00Z", "2023-09-17T00:00:00Z", "2023-09-23T00:00:00Z", "2023-09-24T00:00:00Z", "2023-09-30T00:00:00Z", "2023-10-01T00:00:00Z", "2023-10-07T00:00:00Z", "2023-10-08T00:00:00Z", "2023-10-14T00:00:00Z", "2023-10-15T00:00:00Z", "2023-10-21T00:00:00Z", "2023-10-22T00:00:00Z", "2023-10-28T00:00:00Z", "2023-10-29T00:00:00Z", "2023-11-04T00:00:00Z", "2023-11-05T00:00:00Z", "2023-11-11T00:00:00Z", "2023-11-12T00:00:00Z", "2023-11-18T00:00:00Z", "2023-11-19T00:00:00Z", "2023-11-25T00:00:00Z", "2023-11-26T00:00:00Z", "2023-12-02T00:00:00Z", "2023-12-03T00:00:00Z", "2023-12-09T00:00:00Z", "2023-12-10T00:00:00Z", "2023-12-16T00:00:00Z", "2023-12-17T00:00:00Z", "2023-12-23T00:00:00Z", "2023-12-24T00:00:00Z", "2023-12-30T00:00:00Z", "2023-12-31T00:00:00Z", "2024-01-06T00:00:00Z", "2024-01-07T00:00:00Z", "2024-01-13T00:00:00Z", "2024-01-14T00:00:00Z", "2024-01-20T00:00:00Z", "2024-01-21T00:00:00Z", "2024-01-27T00:00:00Z", "2024-01-28T00:00:00Z", "2024-02-03T00:00:00Z", "2024-02-04T00:00:00Z", "2024-02-10T00:00:00Z", "2024-02-11T00:00:00Z", "2024-02-17T00:00:00Z", "2024-02-18T00:00:00Z"] }, "ResponseCode": 2000, "Messages": [], "Echo": { "RequestTime": "2023-08-18T11:28:02.1985931Z", "ResponseTime": "2023-08-18T11:28:02.2454931Z", "ITransactionID": "8317b946-2f52-45c3-a83e-426d0060e97c" } }
        var responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            await storeData(HOLIDAYS_STORAGE_KEY, {
                StartDate: responseObj.Response.StartDate,
                EndDate: responseObj.Response.EndDate,
                Holidays: responseObj.Response.Holidays
            })
            processHolidaysData(responseObj.Response)
        }

    }

    const processHolidaysData = (holidaysData) => {
        if (!holidaysData?.Holidays) return;
        const today = getTodayAsDate();
        setCalendarMinDate(today);
        setCalendarMaxDate(new Date(holidaysData.EndDate));
        setBankHolidayDates(holidaysData.Holidays.map((dateString) => new Date(dateString.replace('Z', ''))));
        setOneTimeSelectedDate(today);
        dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { key: "TransferDate", value: today } });
        setStartDate(today);
        dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { key: "startDate", value: today } });
    }

    useEffect(() => {
        setTimeout(() => {
        }, 1000);
    }, [oneTimeSelectedDate])
    const onDateChange = (date, type) => {
        if (type == 'oneTime') {
            setOneTimeSelectedDate(date)
            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "TransferDate", 'value': date } })
        } else if (type == 'recurringStartDate') {
            setStartDate(date)
            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "startDate", 'value': date } })
            setEndDate(null)
            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "EndDate", 'value': null } })
        } else if (type == 'recurringEndDate') {
            setEndDate(date)
            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "EndDate", 'value': date } })
        }
    }

    const issSavingPath = location.pathname === '/AccountServices/Savings/TransferMoney'
    const issmiONEPath = location.pathname === '/AccountServices/smiONECard/TransferMoney'
    
    const spendingCard = cards?.find(
        (item) =>
            item.AccountTypeBit63 === 64
    );
    const canShowAddExternalAccount = !issSavingPath && !issmiONEPath && isShowContent && cards !== null && spendingCard?.AllowAddExternalAccount;
    const handleAddExternalAccount = () => {
        if (props?.isTinkFlowEnabled || props?.isPlaidFlowEnable) openHeadsUpModal()
        else {
            navigate('/Settings/ManageExternalAccounts/AddExternalAccount')
        }
    }
    const settingChildren1 = () => {
        return (
            <>

                <div className={`${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}  flex justify-center flex-col  sm:mx-0 mx-4`}></div>

                <p className='pt-4 font-serif-pro font-[400] lg:text-[26px] md:text-[24px] sm:text-[22px] text-[25px]
                         md:leading-[38px] sm:leading-[30px] leading-[34px] text-[var(--transferHeading-text)]
                             mt-4 sm:mx-0 mx-4'>{t("transfer_fund_subheading1")}</p>

                <p className=' font-serif-pro font-[400] lg:text-[26px] md:text-[24px] sm:text-[22px] text-[25px]
                         md:leading-[38px] sm:leading-[30px] leading-[34px] text-[var(--transferSubHeading-text)] sm:mx-0 mx-4'>

                    {location.pathname.toLowerCase() === '/accountservices/spending/transfermoney' ? t("transfer_fund_subheading2_spending") : t("transfer_fund_subheading2_savings")}
                </p>

                {isTransferMoneyFeatureEnabled ? (
                    <div className='flex justify-center sm:w-full mt-12 sm:mx-0 mx-4'>
                        <div className='sm:w-[80%] w-full flex md:gap-8 gap-8 flex-col'>
                            <div className='w-full'>
                                <p className='font-hanken-grotesk text-[var(--input-text-title)] uppercase lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px] font-[600] tracking-[6px] pb-2 block'>{t("amount")}</p>
                                <div className='relative w-full'>
                                <div className='pointer-events-none absolute inset-0 flex items-end justify-center pb-3 font-hanken-grotesk font-[400] leading-none text-[var(--input-text-value)]'>
                                    <span className='lg:text-[64px] md:text-[64px] sm:text-[58px] text-[64px]'>
                                        {`$${enteredAmount ? enteredAmount.toString().split('.')[0] : '0'}`}
                                    </span>
                                    {enteredAmount && enteredAmount.toString().includes('.') && (
                                        <span className='self-center lg:text-[32px] md:text-[32px] sm:text-[29px] text-[32px]'>
                                            {`.${enteredAmount.toString().split('.')[1]}`}
                                        </span>
                                    )}
                                </div>
                                <input
                                    id='transferAmount'
                                    name='transferAmount'
                                    type='text'
                                    className='relative w-full bg-transparent border-0 border-b-[2px] border-[var(--content-border)] text-center font-hanken-grotesk font-[400] lg:text-[64px] md:text-[64px] sm:text-[58px] text-[64px] leading-none pb-3 focus:outline-none text-transparent placeholder:text-transparent caret-[var(--input-text-value)]'
                                    placeholder='$0'
                                    value={enteredAmount ? `$${enteredAmount}` : ''}
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
                                        const amountValue = formattedAmount.toString().replace('$', '');
                                        dispatch({
                                            type: 'TRANSFER_MONEY_PAYLOAD',
                                            payload: { 'key': "Amount", 'value': amountValue }
                                        })
                                        if (amountValue && parseFloat(amountValue) === 0) {
                                            setAmountError(t('amount_validation'));
                                        } else {
                                            setAmountError('');
                                        }
                                    }}
                                    onBlur={(event) => handleOnBlurAmountField(event)}
                                    autoComplete='off'
                                />
                                </div>
                                {amountError && (
                                    <div className='w-full mt-1'>
                                        {kudzuPlusTrue ? displayKudzuplusErrorMessage(amountError) : displayErrorMessage(amountError)}
                                    </div>
                                )}
                            </div>

                            {isShowContent &&
                                <CustomDropdown options={transferFromAccountOptions.length > 0 ? transferFromAccountOptions : [{ Name: t('no_linked_acccounts') }]}
                                    title={t('transfer_money_from')} required onSelect={(option) => {
                                        dispatch({
                                            type: 'TRANSFER_MONEY_PAYLOAD',
                                            payload: { 'key': "FromAccount", 'value': option }
                                        })
                                        // Only call API if this is a different account than currently selected
                                        if (!selectedTransferFromAccount || selectedTransferFromAccount.AccountId !== option.AccountId) {
                                            getNewTransferAccount(option.AccountId, "from")
                                        }
                                    }}
                                    selectedAccountType={selectedTransferFromAccount}
                                    boxed={true} hideArrow={false} error={transferFromError}
                                    actionText={canShowAddExternalAccount ? t("add_external_account") : null}
                                    onActionClick={handleAddExternalAccount} />
                            }
                            {isShowContent &&
                                <CustomDropdown options={transferToAccountOptions.length > 0 ? transferToAccountOptions : [{ Name: t('no_linked_acccounts') }]}
                                    title={t('transfer_money_to')} required onSelect={(option) => {
                                        dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "ToAccount", 'value': option } })
                                        // Only call API if this is a different account than currently selected
                                        if (!selectedTransferToAccount || selectedTransferToAccount.AccountId !== option.AccountId) {
                                            getNewTransferAccount(option.AccountId, "to")
                                        }
                                    }}
                                    selectedAccountType={selectedTransferToAccount}
                                    boxed={true} hideArrow={false} error={transferToError}
                                    actionText={canShowAddExternalAccount ? t("add_external_account") : null}
                                    onActionClick={handleAddExternalAccount} />
                            }


                            <CustomRadioButtonGroup
                                name="frequencyType"
                                title={t('frequency')}
                                options={transferFrequencyOptions}
                                selectedValue={isOneTimeFrequency ? "One Time" : recurringFrequencyName}
                                onSelect={setFrequencyFun}
                                error={freqTypeError || recurringFreqTypeError}
                                isRow={'row'}
                                rowItemsPerLine={3}
                            />


                            {isOneTimeFrequency &&
                                <CustomDatePicker selectedDate={selectedTransferDate} onDateChange={(date) => onDateChange(date, 'oneTime')} minDate={CalendarMinDate} maxDate={CalendarMaxDate} disabledDates={[]} title={t('transfer_date')} hrbg='bg-dropdown-sky' />
                            }
                            {isRecurringFrequency &&
                                <CustomDatePicker selectedDate={startDate} onDateChange={(date) => onDateChange(date, 'recurringStartDate')} minDate={CalendarMinDate} maxDate={CalendarMaxDate} disabledDates={[]} title={t('start_date')} hrbg='bg-dropdown-sky' />
                            }
                            {isRecurringFrequency &&
                                <div className='w-full'>
                                    <CustomDatePicker selectedDate={endDate} onDateChange={(date) => onDateChange(date, 'recurringEndDate')} minDate={startDate} maxDate={CalendarMaxDate} disabledDates={[startDate]} title={t('end_date')} hrbg='bg-dropdown-sky' />
                                    {endDateError && (kudzuPlusTrue ? displayKudzuplusErrorMessage(endDateError) : displayErrorMessage(endDateError))}
                                </div>
                            }

                            {/*  <p className=' font-hanken-grotesk font-[500] text-[16px] leading-[24px] md:text-[14px] md:leading-[22px] sm:text-[12px] sm:leading-[18px] text-[var(--text-clr-transactions)] '>{
                                (!selectedTransferToAccount && !selectedTransferFromAccount) ? ""
                                    :
                                    isAchTransfer ? t('arrive_in_ur_acc') : t('money_arrives')}</p> */}

                            {shouldShowAchDateDisclaimer &&
                                <p className=' font-hanken-grotesk font-[600] text-[16px]
                            leading-[24px] md:text-[14px] md:leading-[22px] sm:text-[12px]
                            sm:leading-[18px] text-[var(--text-clr-transactions)] '>{t('ach_holiday_weekend_disclaimer')}</p>
                            }


                            <CustomTextInput
                                name="Memo (Optional)"
                                onChange={(event) => { dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "Memo", 'value': event.target.value } }) }}
                                value={memo}
                                inputWidth=' w-full'
                                placeholder={t("memo_placeholder_manage_money")}
                                showValidity={!!(memo && memo.trim().length > 0)}
                                isValid={!!(memo && memo.trim().length > 0)}
                            />
                            {/* <span className='font-hanken-grotesk font-[500]
                         lg:text-[14px] md:text-[13px] sm:text-[12px] text-[13px]
                          leading-[22px]'>{location.pathname === '/AccountServices/Checking/TransferMoney' ? t("adding_a_note_to_this_transfer_is_optional") : ''}</span> */}
                        </div>
                    </div>
                ) : (
                        <div className='flex justify-center sm:w-full mt-10 sm:mx-0 mx-4'>
                            <div className='sm:w-[80%] w-full flex md:gap-8 gap-8 flex-col'>
                                {isShowContent &&
                                    <CustomDropdown options={transferFromAccountOptions.length > 0 ? transferFromAccountOptions : [{ Name: t('no_linked_acccounts') }]}
                                        title={t('transfer_money_from')} onSelect={(option) => {
                                            dispatch({
                                                type: 'TRANSFER_MONEY_PAYLOAD',
                                                payload: { 'key': "FromAccount", 'value': option }
                                            })
                                            // Only call API if this is a different account than currently selected
                                            if (!selectedTransferFromAccount || selectedTransferFromAccount.AccountId !== option.AccountId) {
                                                getNewTransferAccount(option.AccountId, "from")
                                            }
                                        }}
                                        selectedAccountType={selectedTransferFromAccount}
                                        hrbg='bg-dropdown-sky' error={transferFromError} />
                                }
                                {isShowContent &&
                                    <CustomDropdown options={transferToAccountOptions.length > 0 ? transferToAccountOptions : [{ Name: t('no_linked_acccounts') }]}
                                        title={t('transfer_money_to')} onSelect={(option) => {
                                            dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "ToAccount", 'value': option } })
                                            // Only call API if this is a different account than currently selected
                                            if (!selectedTransferToAccount || selectedTransferToAccount.AccountId !== option.AccountId) {
                                                getNewTransferAccount(option.AccountId, "to")
                                            }
                                        }}
                                        selectedAccountType={selectedTransferToAccount}
                                        hrbg='bg-dropdown-sky' error={transferToError} />
                                }

                                {!issSavingPath && !issmiONEPath && isShowContent && cards !== null && spendingCard?.AllowAddExternalAccount &&
                                    <button className=' font-hanken-grotesk font-[500] md:font-[700] text-[14px] leading-[20px] md:text-[12px] md:leading-[20px] lg:text-[16px] lg:leading-[24px] text-left
                             text-[var(--addText-color)] cursor-pointer'
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                //  if (twoFactAuthenticationDone) {
                                                if (props?.isTinkFlowEnabled || props?.isPlaidFlowEnable) openHeadsUpModal()
                                                else {
                                                    navigate('/Settings/ManageExternalAccounts/AddExternalAccount')
                                                }
                                                //  } else { 
                                                // props?.onClickAddExternalAcc()

                                                // }

                                            }
                                        }
                                        }
                                        onClick={() => {
                                            //  if (twoFactAuthenticationDone) {
                                            if (props?.isTinkFlowEnabled || props?.isPlaidFlowEnable) openHeadsUpModal()
                                            else {
                                                navigate('/Settings/ManageExternalAccounts/AddExternalAccount')
                                            }
                                            //} 
                                            // else { props?.onClickAddExternalAcc() }
                                            // logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Add_External_Account_Clicked", "Add_External_Account_Clicked", "", "");
                                            // onSetIsExternalAccountAddedSuccessfully(false)
                                        }
                                        }
                                    >
                                        {t("add_external_account")}</button>
                                }


                                <CustomTextInput name={t("amount")}
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
                                        const amountValue = formattedAmount.toString().replace('$', '');
                                        dispatch({
                                            type: 'TRANSFER_MONEY_PAYLOAD',
                                            payload: { 'key': "Amount", 'value': amountValue }
                                        })
                                        if (amountValue && parseFloat(amountValue) === 0) {
                                            setAmountError(t('amount_validation'));
                                        } else {
                                            setAmountError('');
                                        }
                                    }}
                                    value={enteredAmount ? `$${enteredAmount}` : ''}
                                    onBlur={(event) => handleOnBlurAmountField(event)}
                                    error={amountError}
                                    placeholder={"$ 0"}
                                    inputWidth='w-full'
                                />

                                <CustomRadioButtonGroup name="frequencyType" title={t('frequency')} options={frequencyArray} selectedValue={frequency} onSelect={setFrequencyFun} error={freqTypeError} />

                                {isRecurringFrequency &&
                                    <CustomRadioButtonGroup name="recurringFrequency" isTitle={false} options={recurringFrequencyArray} selectedValue={recurringFrequencyName} onSelect={setRecurringFrequencyFun} error={recurringFreqTypeError} />
                                }


                                {isOneTimeFrequency &&
                                    <CustomDatePicker selectedDate={selectedTransferDate} onDateChange={(date) => onDateChange(date, 'oneTime')} minDate={CalendarMinDate} maxDate={CalendarMaxDate} disabledDates={[]} title={t('transfer_date')} hrbg='bg-dropdown-sky' />
                                }
                                {isRecurringFrequency &&
                                    <CustomDatePicker selectedDate={startDate} onDateChange={(date) => onDateChange(date, 'recurringStartDate')} minDate={CalendarMinDate} maxDate={CalendarMaxDate} disabledDates={[]} title={t('start_date')} hrbg='bg-dropdown-sky' />
                                }
                                {isRecurringFrequency &&
                                    <div className='w-full'>
                                        <CustomDatePicker selectedDate={endDate} onDateChange={(date) => onDateChange(date, 'recurringEndDate')} minDate={startDate} maxDate={CalendarMaxDate} disabledDates={[startDate]} title={t('end_date')} hrbg='bg-dropdown-sky' />
                                        {endDateError && (kudzuPlusTrue ? displayKudzuplusErrorMessage(endDateError) : displayErrorMessage(endDateError))}
                                    </div>
                                }

                                <p className=' font-hanken-grotesk font-[500] text-[16px]
                        leading-[24px] md:text-[14px] md:leading-[22px] sm:text-[12px] 
                        sm:leading-[18px] text-[var(--text-clr-transactions)] '>{
                                        (!selectedTransferToAccount && !selectedTransferFromAccount) ? ""
                                            :
                                            isAchTransfer ? t('arrive_in_ur_acc') : t('money_arrives')}</p>

                                {shouldShowAchDateDisclaimer &&
                                    <p className=' font-hanken-grotesk font-[600] text-[16px]
                            leading-[24px] md:text-[14px] md:leading-[22px] sm:text-[12px]
                            sm:leading-[18px] text-[var(--text-clr-transactions)] '>{t('ach_holiday_weekend_disclaimer')}</p>
                                }


                                <CustomTextInput
                                    name="Memo (Optional)"
                                    onChange={(event) => { dispatch({ type: 'TRANSFER_MONEY_PAYLOAD', payload: { 'key': "Memo", 'value': event.target.value } }) }}
                                    value={memo}
                                    inputWidth=' w-full'
                                    placeholder={t("memo_placeholder")}
                                />
                                {/* <span className='font-hanken-grotesk font-[500]
                         lg:text-[14px] md:text-[13px] sm:text-[12px] text-[13px]
                          leading-[22px]'>{location.pathname === '/AccountServices/Checking/TransferMoney' ? t("adding_a_note_to_this_transfer_is_optional") : ''}</span> */}
                            </div>
                        </div>
                )}

                

                <div className='flex sm:justify-end justify-between md:pb-20 sm:pb-10 pb-20  pt-10 gap-11 sm:mx-0 mx-4'>
                    <button className=' font-hanken-grotesk font-[600]
                                     md:font-[700] leading-[26px] 
                                     lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                      md:leading-[13px]
                                      lg:leading-[18px] text-[var(--resetTextColor)] cursor-pointer 
                                      capitalize' onClick={handleReset}>{t("reset")}</button>

                    <button disabled={amountError ? true : false} className='font-hanken-grotesk flex items-center font-[600] md:font-[700] 
                         leading-[26px] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          md:leading-[13px] 
                          lg:leading-[18px] text-[var(--resetTextColor)] cursor-pointer ' onClick={handleNextClick}>
                        {t("next")}<img src={appThemeData.transferRightArrow} alt="RadialNull" className='lg:h-[15px] lg:w-[14px]
                        md:h-[14px] md:w-[13px] sm:h-[12px] sm:w-[12px] h-[13px] w-[14px] ml-1' /></button>
                </div>


                {/* <p className=' font-hanken-grotesk font-[600]
                                     md:font-[700] text-[19px] leading-[26px] 
                                     md:text-[13px] md:leading-[13px] lg:text-[18px]
                                      lg:leading-[18px] text-secondary-2 cursor-pointer 
                                      capitalize' onClick={handleReset}>{t("reset")}</p>
                                        <p className=' font-hanken-grotesk font-[600] md:font-[700] text-[19px] leading-[26px] md:text-[13px] md:leading-[13px] lg:text-[18px] lg:leading-[18px] text-secondary-2 ' onClick={handleNextClick}>{t("next")}</p>
                                    <img src={RightArrow} alt="RadialNull" className='h-[7px] w-[12px] 
                                            md:h-[10px] md:w-[11px]  lg:h-[17px] lg:w-[17px] ml-1' /> */}


            </>
        )
    }



    return (

        <>
            <DynamicCard
                header={true}
                CardRadius={true}
                cardWidth={width.allpolicies}
                HeaderRadius={true}
                isWhite={appThemeData.isWhiteBgForCard}
                isDarkForKudzu={appThemeData.isDarkBgForCard}
                backgroundColor={'--cardHeading-bg'}
                HeaderContent={
                    <>
                        <CardHeading heading={t('transfer_money')} />
                    </>
                }


            >
                {settingChildren1()}
            </DynamicCard>

            {isLoading && <Loader />}
        </>
    )
}


export default withOidcSecure(TransferMoneyForm)

